import { render, staticRenderFns } from "./mdInSubmitToAction.vue?vue&type=template&id=7354e0ab&scoped=true"
import script from "./mdInSubmitToAction.vue?vue&type=script&lang=js"
export * from "./mdInSubmitToAction.vue?vue&type=script&lang=js"
import style0 from "./mdInSubmitToAction.vue?vue&type=style&index=0&id=7354e0ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7354e0ab",
  null
  
)

export default component.exports